import React from 'react'
import { Box, Card, Typography, useMediaQuery } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { addDays, format } from 'date-fns'

import { formatCentsToPrettyDollars } from './giftCardUtils'
import { getProgramDays } from './utils'
import EditableEndDate from './EditableEndDate'

const useStyles = makeStyles({
  root: {
    height: '100%',
  },
})

const SummaryItem = ({ label, value }) => {
  return (
    <Box>
      <Typography variant="overline" display="block" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body2">{value}</Typography>
    </Box>
  )
}

const EditableSummaryItem = ({ label, editComponent }) => {
  return (
    <Box>
      <Typography variant="overline" display="block" color="textSecondary">
        {label}
      </Typography>
      {editComponent}
    </Box>
  )
}

const CardProgramSummary = ({ program, isUpdatingProgram, onUpdateProgram }) => {
  const classes = useStyles()
  const mobileView = useMediaQuery(theme => theme.breakpoints.down('xs'))

  const days = getProgramDays(program.schedule)

  // WARNING This is a TEMPORARY fix as the end date is exclusive in the backend
  // We need to subtract a day here because we add a day when creating/updating
  // just so users can use the program on the day they select
  const defaultEndDate = program.endDate
    ? format(addDays(program.endDate, -1), 'YYYY-MM-DD')
    : undefined
  return (
    <Card className={classes.root}>
      <Typography variant="h6">Subsidy detail</Typography>
      <Box
        display="flex"
        flexDirection={mobileView ? 'column' : 'row'}
        justifyContent={mobileView ? 'flex-start' : 'space-between'}
        mt={3}
      >
        <SummaryItem
          label="Amount"
          value={`${formatCentsToPrettyDollars(program.discountAmountInPennies)} Daily`}
        />
        <SummaryItem label="Days" value={days} />
        <SummaryItem label="Start date" value={format(program.startDate, 'MM/DD/YYYY')} />
        <EditableSummaryItem
          label="End date"
          editComponent={
            <EditableEndDate
              defaultValue={defaultEndDate}
              submitting={isUpdatingProgram}
              onSubmit={value => onUpdateProgram({ endDate: value })}
            />
          }
        />
      </Box>
    </Card>
  )
}

export default CardProgramSummary
